import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const fetchComplaints = createAsyncThunk(
  'Complaints/fetchComplaints',
  async (id_company, thunkAPI) => {
    const { rejectWithValue  } = thunkAPI;
    try {
     
     
      const res = await axios.get(`${BaseUrl}/AllComplaints/${id_company}`, {       headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, });
      const result = await res.data.data;
      return result;
    } catch (error) {
       if (error.response && error.response.status === 401) {
        // Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);



const ComplaintsSlice = createSlice({
  name: 'Complaints',
  initialState: { Complaint: [], loading: false, error: null },
  reducers: {
    clearComplaints: (state) => {
      state.Complaint = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: {
    //fetch
    [fetchComplaints.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchComplaints.fulfilled]: (state, action) => {
      state.Complaint = action.payload;
      state.loading = false;
    },
    [fetchComplaints.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const { clearComplaints } = ComplaintsSlice.actions;
export default ComplaintsSlice.reducer;
